export { default } from './ResourcePlanContainer';
